import comp from "./SubQuestions";
export default comp;
